import { Tournament } from "model/Tournament/Tournament";
import { nonUndefined } from "Utility";
import { mapTournamentSegments } from "./Segment/FsTournamentSegment";
import { mapPrizes } from "./FsPrize";
import { mapRankingGroups } from "./FsRankingGroup";
import { FsTournament } from "db/model/tournament/FsTournament";
import { mapTournamentSegmentLinks } from "./Segment/FsTournamentSegmentLink";
import { mapTournamentTeams } from "./FsTournamentTeams";
import { mapMultiple } from "../Utility";
import { mapTournamentTrack } from "./FsTournamentTrack";

export const mapTournament = (
  fsModel: FsTournament,
  id: string
): Tournament | undefined => {
  if (
    !fsModel.name ||
    !fsModel.startTimeMs ||
    !fsModel.endTimeMs ||
    !fsModel.teams
  ) {
    return undefined;
  }

  const teams = mapTournamentTeams(fsModel.teams);
  if (!teams) {
    return undefined;
  }

  return {
    id,
    description: fsModel.description,
    endTimeMs: fsModel.endTimeMs,
    filterName: fsModel.filterName ?? fsModel.name,
    imageIdOverride: fsModel.imageIdOverride,
    links: fsModel.links,
    name: fsModel.name,
    prizes: !!fsModel.prizes
      ? mapPrizes(nonUndefined(fsModel.prizes))
      : undefined,
    rankingGroups: !!fsModel.rankingGroups
      ? mapRankingGroups(nonUndefined(fsModel.rankingGroups))
      : undefined,
    segments: mapTournamentSegments(fsModel.segments ?? []),
    segmentLinks: !!fsModel.segmentLinks
      ? mapTournamentSegmentLinks(fsModel.segmentLinks)
      : undefined,
    startTimeMs: fsModel.startTimeMs,
    teams,
    theme: fsModel.theme,
    tracks: mapMultiple(fsModel.tracks, mapTournamentTrack) ?? [],
    trigram: fsModel.trigram ?? id,
  };
};
